export const ENVIRONMENT: string = import.meta.env.VITE_ENVIRONMENT;
export const API = import.meta.env.VITE_BASE_API;
export const APP_CODE = import.meta.env.VITE_APP_CODE
export const IMAGE_VISOR = import.meta.env.VITE_IMAGE_VISOR;

const URL_SECURITY = `${API}/security/api/`;
let   URL_CUSTOMS = `${API}/customs/api/`;
const URL_CATALOG = `${API}/catalog/api/`;
const URL_PERSON = `${API}/person/api/`;
const URL_SENAE = `${API}/senae/api/`;
const URL_CRM = `${API}/crm/api/`;

const getServicesSubdomain = () => {
    const env = (import.meta.env.VITE_ENVIRONMENT || '').toLowerCase();
    if (env === 'dev' || env === 'development') return 'dev-services';
    if (env === 'qa') return 'qa-services';
    return 'services';
};

//URL_CUSTOMS = `http://localhost:7021/api/`;

const SERVICES_BASE_URL = `https://${getServicesSubdomain()}.diligent.la`;
const URL_MEDIA = `${SERVICES_BASE_URL}/common/media/api/resources/`;


export const SecurityPathsEnum: Record<string, string> = {
    Auth: 'auth',
    AuthById: 'auth/by_identification',
    Companies: 'companies',
    Menu: 'menus',
    MenuAssignments: 'menu_assignments',
    Applications: 'applications',
    UserApplications: 'user_applications',
    Rol: 'roles',
    RolMenu: 'role_menu_templates',
    Users: 'users',
    UserCompanyRol: 'user_company_roles',
    Log: 'user_access_logs',
    Priviliges: 'privileges',
    UserAppRol: 'user_application_role',
    CheckSum: 'checksums',
    Configurations: 'configurations',
    UserProfile: 'user_profiles',
    UserCompany: 'user_company'
}

export const CustomsPathsEnum: Record<string, string> = {
    DashboardOrdersQuantity: 'dashboards/badgets/orders_quantity',
    DashboardObserverOrdersQuantity: 'dashboards/badgets/observed_orders_quantity',
    DashboardOrdersInAforoQuantity: 'dashboards/badgets/orders_in_inspection_quantity',
    DashboardOrdersInPhysicalInspection: 'dashboards/badgets/orders_in_physical_inspection_quantity',
    DashboardActiveOrdersQuantity: 'dashboards/badgets/active_orders_quantity',
    DashboardOrdersPendingTempFile: 'dashboards/badgets/orders_pending_temp_file',
    DashboardUndeclaredOrdersQuantity: 'dashboards/badgets/undeclared_orders_quantity',
    DashboardReadyBillingProcessesQuantity: 'dashboards/badgets/ready_billing_processes_quantity',
    DashboardDocumentExpirationQuantity: 'dashboards/badgets/document_expiration_quantity',

    DasboardTopTenClients: 'dashboards/top_ten',
    DasboardOrdersByAdvisors: 'dashboards/orders_advisors',
    DasboardOrdersAverageTimeByAdvisors: 'dashboards/average_days_by_advisors',
    DashboardOrdersChannel: 'dashboards/orders_channels',
    DashboardOrdersChannelPercentage: 'dashboards/orders_channels_percentage',
    DashboardOrdersByRegimen: 'dashboards/orders_by_regimen',
    DashboardOrdersYearlyComparisonByMonth: 'dashboards/orders_yearly_comparison_by_month',
    DashboardOrdersAverageDocumentAcceptanceTime: 'dashboards/orders_average_document_to_acceptance_time',
    DashboardAveragePhysicalInspectionClosureTime: 'dashboards/average_physical_inspection_closure_time',
    DashboardAverageArrivalDeclarationTime: 'dashboards/average_arrival_to_declaration_time',
    DashboardAverageCustomsCleareanceTime: 'dashboards/average_customs_clearance_time',

    AdvisorTeam: 'advisor_teams',

    CustomsDestinationConfig: 'customs_destination_configs',
    OtherServiceConfig: 'other_service_configs',
    // Proxy propio hacia net.diligentec.api.inventory (vía inventory.srv) — el frontend nunca
    // llama a Inventory directo, pasa siempre por el backend de Customs. Mismo criterio que
    // net.diligent.web.crm's InventoryItemsController.
    InventoryItems: 'inventory-items'
}

export const DataMasterPathsEnum: Record<string, string> = {
    Companies: 'companies',
}

export const SecurityPathBuilder = (paths: string): string =>
    `${URL_SECURITY}${paths}`;

export const CustomsPathBuilder = (paths: string): string =>
    `${URL_CUSTOMS}${paths}`;

export const PersonPathBuilder = (paths: string): string =>
    `${URL_PERSON}${paths}`;

export const SenaePathBuilder = (paths: string): string =>
    `${URL_SENAE}${paths}`;

export const DataMasterPathBuilder = (paths: string): string =>
    `${URL_CATALOG}${paths}`;

export const MediaPathBuilder = (displayId: string): string =>
    `${URL_MEDIA}${displayId}`;

export const CrmPathBuilder = (paths: string): string =>
    `${URL_CRM}${paths}`;


export const BuildUrlParams = (params: Record<string, string | string[] | undefined>): string => {
    const urlParts: string[] = [];

    Object.entries(params).forEach(([key, value]) => {
        if (Array.isArray(value)) {
            value.forEach(item => {

                if (item !== undefined && item !== null && item !== '') {
                    urlParts.push(`${encodeURIComponent(key)}=${encodeURIComponent(item)}`);
                }
            });
        } else if (value !== undefined && value !== null && value !== '') {
            urlParts.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`);
        }
    });

    return urlParts.join('&');
}